import Lookup from 'src/componentes/select2';

const CriticidadeCargoLookup = ({ ...rest }) => <Lookup labelKey="nome" valueKey="id" url="/CriticidadeCargoLookup" {...rest} />;

export default CriticidadeCargoLookup;
